import React,{useState, useEffect, useRef,} from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "../../../api/axios";
import Swal from 'sweetalert2';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { getCookie } from "../../../utils/cookieUtils";

const PRESTASI_URL = "/prestasi-peserta-didik"


const DetailPrestasi = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const userRef = useRef();
  const [namaPrestasi, setNamaPrestasi] = useState("");
  const [gambarPrestasi, setGambarPrestasi] = useState("");
  const [PemenangPrestasi, setPemenangPrestasi] = useState("");
  const [SkalaPrestasi, setSkalaPrestasi] = useState("");
  const [TanggalPrestasi, setTanggalPrestasi] = useState("");
  const [quillContent, setQuillContent] = useState("");
  const [image, setImage] = useState("");

  const token = getCookie("_auth");
    
    const location = useLocation();
    const { isFormDisabled } = location.state || {};


    useEffect(() => {
        if (userRef.current) {
          userRef.current.focus();
        }
        if (id) {
            // Fetch existing data based on ID
            fetchPrestasi();
          }
      }, [id]);

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      const fetchPrestasi = async () => {
        try {
          const resp = await axios.get(`${PRESTASI_URL}/${id}`, {
            headers: {
              "Authorization": `Bearer ${token}`,
              "Accept": "appliaction/json",
            },
          });
        //   console.log(resp.data);
          setNamaPrestasi(resp.data?.data?.title);
          setPemenangPrestasi(resp.data?.data?.name);
          setSkalaPrestasi(resp.data?.data?.scale);
          setTanggalPrestasi(resp.data?.data?.date);
          setQuillContent(resp.data?.data?.content);
          setImage(resp.data?.data?.image);

        } catch (error) {
          console.log(error?.response?.data);
        }
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
      const formData = new FormData();
      formData.append("title", namaPrestasi);
      formData.append("name", PemenangPrestasi);
      formData.append("scale", SkalaPrestasi);
      formData.append("date", TanggalPrestasi);
      formData.append("content", quillContent);
      formData.append("file", gambarPrestasi);

      // formData.append("desc", desc);

        try {
          if(id){
            // Edit
      const resp = await axios.post(`${PRESTASI_URL}/${id}?_method=PATCH`, formData, {
        headers: {
          "Content-type": "multipart/form-data",
          "Accept": "appliaction/json",
          "Authorization": `Bearer ${token}`
        },
      });
      Toast.fire({
        icon: 'success',
        title: 'Berhasil Mengedit Prestasi'
      });
      navigate("/admin/posting-prestasi", { replace: true });
    } 
    // Post
    else {
      const resp = await axios.post(PRESTASI_URL, formData, {
        headers: { 
          "Content-type": "multipart/form-data",
          "Accept" : "appliaction/json",
          "Authorization" : `Bearer ${token}`
       },
        // withCredentials:true
      });
      
          setNamaPrestasi("");
          setPemenangPrestasi("");
          setSkalaPrestasi("");
          setTanggalPrestasi("");
          setQuillContent("");
          setGambarPrestasi("");
      Toast.fire({
        icon: 'success',
        title: 'Berhasil Menambahkan Prestasi'
      });
      navigate("/admin/posting-prestasi", { replace: true });
    }
      } catch (error) {
          Toast.fire({
            icon: 'error',
            title: error?.response?.data?.message
          });
          console.log(quillContent);
          console.log(error?.response?.data);
        }
      };

  return (
    <div className="container-fluid p-0">
            <div className="bg">  
                    <div className="row">
                        <div className="col">
                            <img src="/img/HEADER.png" alt="" className="mr-3 me-3 w-100 d-block"  />
                        </div>
                    </div>
            </div>
            <div className="content">
                <div className="container shadow" style={{ backgroundColor:"#fff",padding:"20px 40px" }}>
                    <div className="row mb-5" style={{ padding:"10px 80px" }}>
                        <div className="col ">
                            <h1 style={{ fontWeight:"bold",color:"#061745",textAlign:"center" }}>{id ? "Edit Prestasi" : "Tambah Prestasi"}</h1>
                            <hr style={{ width:"15%",border: "none",borderTop: "4px solid #FFB606",opacity:"100%",margin:"20px auto" }}/>
                            <form onSubmit={handleSubmit}>
                            <div className="form-group">
                            <label htmlFor="namaPrestasi">Nama Prestasi:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="namaPrestasi"
                                value={namaPrestasi}
                                onChange={(e) => setNamaPrestasi(e.target.value)}
                            />
                            </div>
                            <div className="form-group mt-4">
                            <label htmlFor="PemenangPrestasi">Pemenang Prestasi:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="PemenangPrestasi"
                                value={PemenangPrestasi}
                                onChange={(e) => setPemenangPrestasi(e.target.value)}
                            /> 
                            </div>
                            <div className="form-group mt-4">
                            <label htmlFor="SkalaPrestasi">Skala Prestasi:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="SkalaPrestasi"
                                value={SkalaPrestasi}
                                onChange={(e) => setSkalaPrestasi(e.target.value)}
                            /> 
                            </div>
                            <div className="form-group mt-4">
                            <label htmlFor="TanggalPrestasi">Tanggal Prestasi:</label>
                            <input
                                type="date"
                                className="form-control"
                                id="TanggalPrestasi"
                                value={TanggalPrestasi}
                                onChange={(e) => setTanggalPrestasi(e.target.value)}
                            /> 
                            </div>
                            <div className="form-group mt-4">
                            <label htmlFor="DeskripsiPrestasi">Deskripsi Prestasi:</label>
                            <ReactQuill 
                             value={quillContent}
                             disabled={isFormDisabled}
                             onChange={setQuillContent}
                            />
                            </div>
                            {image && (
                            <div className="mt-4">
                                <label className="form-label">Gambar saat ini:</label>
                                <img src={'https://smkn6jakarta.sch.id/app/storage/prestasi-peserta-didik/'+image} alt="Gambar saat ini" className="img-fluid" />
                            </div>
                            )}
                            <div className="form-group mt-4">
                            <label htmlFor="GambarPrestasi">Gambar Prestasi:</label>
                            <input
                                type="file"
                                className="form-control"
                                id="GambarPrestasi"
                                accept="image/*"
                                // value={gambarPrestasi}
                                onChange={(e) => setGambarPrestasi(e.target.files[0])}
                            />
                            <div id="UploadImage" className="form-text">ukuran maksimal 2mb</div> 
                            </div>
                            <div className="form-group">
                            <button type="submit" className="btn btn-primary mt-3" disabled={id ? true : false}>Submit{" "}</button>
                            <button type="submit" className="btn btn-warning ms-3 mt-3" disabled={id ? false : true}>Edit{" "}</button>
                            <Link to="/admin/posting-prestasi" className="btn btn-primary mt-3 ms-3" style={{ background:"#061745" }}>Kembali</Link>
                            </div>
                        </form>
                            
                                                       
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

  );
};

export default DetailPrestasi;
